import '../scss/taro/_taro_style.scss';

import './inner_navigation.js';
import './navigation.js';
import './table_accordion.js';
import './venobox.js';
import './event_calendar.js';
import './scroll_effect.js';
// // グローバルファンクション
// import "./global_functions.js";

// // 無限スクロールアニメーション
// import "./animations/gs_inifinity_scroll.js";
// // aosjs
// import "./animations/aos.js";
// // スクロールトップボタン処理
// import "./animations/scrolltop.js";





////////////////////////////////////////////////////////
// 以下ファイル化する

// 枠用DOM
const NAV_TOP_BLOCK = "es--nav--top--block";
const NAV_SEARCH_BLOCK = "es--search--wrap";
const NAV_BUTTON_WRAP = "es--nav--button--wrap";

// 移動するDOM
const NAV_GLOBAL_MENU = "es--global--nav";
const NAV_LANGUAGE_MENU = "es--language--nav";
const NAV_SEARCH_FORM = "es--head--search--sns--block";
document.addEventListener("DOMContentLoaded", function () {
    //

    // 横幅チェック関数
    function checkWidth() {
        if (window.innerWidth > 959) {
            // PCモードの処理

            // グローバルナビと言語ナビをトップブロックに移動
            moveDom(NAV_GLOBAL_MENU, NAV_TOP_BLOCK);
            moveDom(NAV_LANGUAGE_MENU, NAV_TOP_BLOCK);
            moveDom(NAV_SEARCH_FORM, NAV_SEARCH_BLOCK);
            console.log(true);
        } else {
            // モバイルモードの処理
            console.log(false);
            // グローバルナビと言語ナビをトップブロックに移動
            // 移動させたい要素を取得
            const elementToMove = document.getElementById(NAV_GLOBAL_MENU);
            if (elementToMove.parentNode.id === NAV_TOP_BLOCK) {
                // #es--mobile--nav--wrapの直下にあるnav要素を取得
                const navElement = document.getElementById("es--mobile--nav--block");
                // nav要素の最後にelementToMoveを追加
                navElement.prepend(elementToMove);
                const elementToMove2 = document.getElementById(NAV_LANGUAGE_MENU);
                // #es--mobile--nav--wrapの直下にあるnav要素を取得
                // nav要素の最後にelementToMoveを追加
                navElement.appendChild(elementToMove2);
            } else {
                console.log("移動する必要なしMB");
            }
            // サーチフォームブロックを移動

            moveDom(NAV_SEARCH_FORM, "es--mobile--nav--wrap");
        }
    }

    // リサイズイベントのデバウンス用変数
    let resizeTimer;

    // ウィンドウのリサイズイベント処理
    window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(checkWidth, 250); // 250ミリ秒後に横幅をチェック
    });

    // 初回の横幅チェック
    checkWidth();
});

// 特定のDOMを指定の位置に移動する関数
function moveDom(dom, target) {
    const targetDom = document.getElementById(target);
    const moveDom = document.getElementById(dom);
    // 両方成功してたら
    if (targetDom && moveDom) {
        // 同じ親要素の場合は移動させない
        if (targetDom.id !== moveDom.parentNode.id) {
            // 問題なければ移動
            targetDom.appendChild(moveDom);
        } else {
            console.log("移動する必要なしPC");
        }
    } else {
        console.log("どっちかだめ");
        console.log(targetDom);
        console.log(moveDom);
    }
}

/* swiper */

var swiper = new Swiper(".heroSwiper", {
    speed: 600,
    parallax: true,
    autoplay: {
        delay: 5000,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

var kagakuSwiper = new Swiper('.kagakuSwiperMenu', {
    // Optional parameters
    autoplay: {
        delay: 5000
    },
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    // Responsive breakpoints
    breakpoints: {
        // when window width is <= 600px
        720: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        959: {
            slidesPerView: 3,
            spaceBetween: 20
        }
    },
});

var taroEventSwiper = new Swiper('.event-list-wrap .taroEventSwiperMenu', {
    // Optional parameters
    autoplay: {
        delay: 5000
    },
    // loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: '.event-list-wrap .swiper-button-next',
        prevEl: '.event-list-wrap .swiper-button-prev'
    },
    // Responsive breakpoints
    breakpoints: {
        // when window width is <= 600px
        720: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        959: {
            slidesPerView: 4,
            spaceBetween: 20
        }
    },
});
//# sourceURL=webpack://lp_create_kit/./src/js/index.js?